module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter",
    attrs: {
      "id": "ch00_fm05_dedic"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("For Pat Kavanagh")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("My thanks are due to Don and Ruth Rendell whose hospitality gave me the space to work. To everyone at Bloomsbury, especially Liz Calder. To Philippa Brewster for her patience."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33cd137c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_dedic.vue
// module id = 75
// module chunks = 0